module.exports = __webpack_public_path__ + "img/learner-quiz-Collector.1e036a8e.png";